import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import AddEnhancedButton from 'components/ui/buttons/AddEnhancedButton';
import TenantPage from 'layouts/TenantPage';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { locationService } from 'shared/services';
import { LocationColumns } from '../locations';

export const Locations = () => {
  const translationPrefix = 'pages.locations.list';
  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const columns: GridColDef[] = LocationColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      pageType="locations"
      menuRight={<AddEnhancedButton prefix={translationPrefix} to="new" requireTenantAdmin />}>
      <EnhancedDataGrid columns={columns} service={locationService} refresh={datagridRefresh} />
    </TenantPage>
  );
};
